import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { compose, prop, sortBy } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';

import codelistProvider from 'components/decorators/codelistProvider';
import { codelists } from 'constants/codelists';
import taskFeedback from 'features/views/taskFeedback';
import { closeFeedback as resetTemporarilySetFeedbackById } from 'features/views/taskFeedback/actions';
import formDescriptorFn, { TASK_FEEDBACK_FORM_NAME } from 'features/views/taskFeedback/form';
import { filterCodelistById } from 'utils';

import FeedbackButton from './FeedbackButton';
import FeedbackConfirm from './FeedbackConfirm';
import FeedbackInfo from './FeedbackInfo';

export const TaskFeedback = ({ finishTypesCodelist, task }) => {
	const dispatch = useDispatch();

	const filteredFinishTypes = filterCodelistById(task.taskTypeId, finishTypesCodelist, 'taskTypeId');
	const sortedFilteredFinishTypes = sortBy(prop('finishTypeId'))(filteredFinishTypes);
	const feedbackData = useSelector((state) => taskFeedback.selectors.getFeedbackData(state, task.taskTypeId));

	useEffect(
		() => () => {
			dispatch(resetTemporarilySetFeedbackById(task?.taskTypeId));
		},
		[dispatch, task?.taskTypeId],
	);

	return (
		<Form name={TASK_FEEDBACK_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Stack spacing={2}>
				<Stack
					direction="row"
					spacing={2}
					useFlexGap
					sx={{
						flexWrap: 'wrap',
					}}
				>
					{sortedFilteredFinishTypes.map((item, i) => (
						<FeedbackButton
							key={i}
							item={item}
							taskFinishTypeId={task.finishTypeId}
							feedbackData={feedbackData}
							taskTypeId={task.taskTypeId}
							statusId={task.statusId}
							solverIsLoggedUser={task.solverIsLoggedUser}
							finishTypeId={item.finishTypeId}
						/>
					))}
				</Stack>

				{task.statusId === 3 && ( // statusId === 3 - task done
					<FeedbackInfo task={task} />
				)}

				{feedbackData.open && (
					<FeedbackConfirm
						taskId={task.id}
						taskTypeId={task.taskTypeId}
						statusId={task.statusId}
						feedbackData={feedbackData}
					/>
				)}
			</Stack>
		</Form>
	);
};

TaskFeedback.propTypes = {
	feedbackData: PropTypes.object,
	finishTypesCodelist: PropTypes.array,
	task: PropTypes.object,
};

export default compose(codelistProvider(codelists.finishTypes, 'finishTypesCodelist'))(TaskFeedback);
